export default {
  YEAR_WIDTH: 46,

  MAX_LAYER_COUNT: 4,
  MAX_EVENT_WIDTH: 142,
  MAX_EVENT_HEIGHT: 142,
  EVENT_MARGIN: 10,

  LINE_HEIGHT: 20,
};



// WEBPACK FOOTER //
// ./src/components/lifeline/config.js